import React from "react";
import { ClickOutside } from "./../../ui-components/index.js";
import DropdownMenu from "./DropdownMenu.js";
const ContextMenu = ({
  onClickOutside,
  contextMenuData,
  playBackMenuData,
  showContextMenu,
  showPlaybackMenu
}) => {
  return /* @__PURE__ */ React.createElement(ClickOutside, { onClickOutside }, showContextMenu && /* @__PURE__ */ React.createElement(DropdownMenu, { options: contextMenuData, onClose: onClickOutside }), showPlaybackMenu && /* @__PURE__ */ React.createElement(DropdownMenu, { options: playBackMenuData, onClose: onClickOutside }));
};
var ContextMenu_default = ContextMenu;
export {
  ContextMenu_default as default
};
//# sourceMappingURL=ContextMenu.js.map
